import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Installable app: register the service worker in production builds only so
// dev servers never serve a stale shell.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    // updateViaCache "none": the browser always re-checks service-worker.js
    // itself instead of trusting an HTTP-cached copy.
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => reg.update())
      .catch(() => {});
  });
}
